/**
 * created by hezq on 2019-10-24
 *
 * description： 通用模块接口地址配置
 *
 */

const config = require('libs/config.js');

const common = {
	// 定时刷新token接口地址【post】
	refreshToken: config.API_MB + '/login/refresh/token',
	// 根据userid获取登录用户信息【get】
	getUserInfo: config.API_MB + '/login/user/info',
	// 退出登录【post】
	doLoginOut: config.API_MB + '/login/dologout',
	// 获取业务平台列表
	getBusinessList: config.MS_SP_PATH + '/v1/business/list',
	// 获取审批对象
	getCheckCode: config.MS_SP_PATH + '/v1/spObjMg/spObjs',
	// 获取登录用户的权限
	getQxs: (ssid)=> `${config.MS_AUTH_PATH}/v1/qxusifMg/auth/menuByGid/${ssid}/1`,
};

export default common;



// WEBPACK FOOTER //
// ./src/api/common.js